"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleLogWithTime = void 0;
function consoleLogWithTime(text) {
    const time = `[${new Date(Date.now()).toLocaleString()}]`;
    const lines = text.split(/\r?\n/);
    lines.forEach((line, index) => {
        const prefix = index === 0 ? time : ' '.repeat(time.length);
        console.log(`${prefix} | ${line}`);
    });
}
exports.consoleLogWithTime = consoleLogWithTime;
//# sourceMappingURL=debug.js.map